export default "__VITE_ASSET__GsBQX$Lz__"